import { ClientSideConfig, PresetViewsGroupTypes } from './stores/types';

export const groupFilters = [
	{
		groupType: PresetViewsGroupTypes.View,
		keyFunc: (userPresetView: ClientSideConfig) => userPresetView.view
	}
];
